const mutations = {
  setBenefitTypes(state, types) {
    state.benefitTypes = types;
  },
  setBenefitType(state, type) {
    state.benefitType = type
  },
};

export default mutations;